import {cylinder_pos, last_symbol, print_reels, symbols} from "./adapters/madnesGameAdapter";
import {get_reel_symbol_name} from "./turbo27_reels";
import {madnes_get_texture, madnes_set_pos_y, madnes_set_texture} from "../framework/src/engine/madnes/madnes_object";
import {
    rotated,
    alldone,
    behavior_config,
    forcestopnow,
    fps, ico_he,
    picture_convert, reels_lenghts, reels_pos,
    round_running,
    set_rotated, set_round_running,
    server_config, server_result,
    in_free_spins, set_forcestopnow, states
} from "../framework/src/engine/madnes/madnes_variables";
import {madnes_audio_fade_out, madnes_audio_play, madnes_audio_stop} from "../framework/src/engine/madnes/madnes_audio";
import {AnimOscilation} from "./turbo27_extanims";
import {
    madnes_is_in_autostart,
    madnes_reels_start,
    madnes_reels_stop,
    madnes_win_anim_reset
} from "../framework/src/engine/madnes/madnes";
import {madnes_add_to_render, madnes_rem_from_render} from "../framework/src/engine/madnes/madnes_render";
import {fadeout_all_27, fadeout_all_lines, osc_reels, result_control, set_osc_reels} from "./turbo27_core_res_ctrl";
import {result_lock, t27_print_reels} from "./turbo27_core_printer";
import {getRandomInt} from "../framework/src/helpers";
import {STATES} from "../framework/src/states/states";

var last_win = 0;
var rotate_start_time = 0;
var rotate_start_pos = [];
var rotate_start_in_accel = 0;
var rotate_start_swing = 0;
var can_stop = 0;
var rotate_control_start_time = 0;
var rotate_control_swing_end = 0;

var frame_blur = 1;
var frame_sharp = 0;

var autospin_force = false;
var autospin_force_enabled = false;

var audioForceStopPlayed = false;
var audioForceJokerPlayed = false;
var audioForceBonusPlayed = false;

function get_current_time()
{
    return window.performance ? window.performance.now() : new Date().getTime();
}

/**
 * @param {boolean=} oscilate
 * @returns {undefined}
 */
export function t27_rotate_run()
{
    if(round_running)
    {
        return;
    }

    if(osc_reels) {

        set_osc_reels(false);
        oscilate_reels().then(rotate_start);

    } else {

        rotate_start();

    }
}

function oscilate_reels()
{
    return new Promise(function(resolve) {

        // madnes_hide_skip();
        // madnes_show_stop();

        var oscilations = [];

        oscilations[0] = new AnimOscilation("reel_group_0", -5, 90);
        oscilations[1] = new AnimOscilation("reel_group_1", 5, 90);
        oscilations[2] = new AnimOscilation("reel_group_2", -5, 90);

        madnes_audio_play("bonus_start");

        oscilations[0].run();
        oscilations[1].run();
        oscilations[2].run();

        setTimeout(function() {
            for(var i = 0; i < oscilations.length; i++) {
                oscilations[i].stop();
                madnes_set_pos_y("reel_group_" + i, 0);
            }
            resolve();
        }, 3000);
    });
}

var random_spin_sound = 0;

var spin_start_time = null;
function rotate_start()
{
    autospin_force_enabled = false;

    if(rotated == 0)
    {
        //console.time('rotate');
        // madnes_on_round_start();

        last_win = 0;
        spin_start_time = get_current_time();

        // madnes_show_stop();

        madnes_win_anim_reset();

        for(var i = 0; i < server_config.logic.reels.length; i++)
        {
            while(stopposin[i] > server_config.logic.reels[i].length)
            {
                stopposin[i] = stopposin[i] * 1 - server_config.logic.reels[i].length;
                stopposin_old[i] = stopposin[i];
                reels_pos[i] = stopposin[i] * ico_he;
            }
        }

        // if(autostart != "∞" && autostart*1 > 0 && !in_free_spins)
        // {
        // 	autostart = autostart*1-1;
        // }
        set_rotated(1);

        startposin = JSON.parse(JSON.stringify(stopposin));

        random_spin_sound = getRandomInt(0, 2);

        if(in_free_spins)
        {
            madnes_audio_play("reel_fs_" + random_spin_sound);
        }
        else
        {
            madnes_audio_play("reel_" + random_spin_sound);
        }

        fadeout_all_lines();
        setTimeout(fadeout_all_27, 300);

        if(!in_free_spins)
        {
            // madnes_new_round();
        }
        else
        {
            set_round_running(true);
        }

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            symbols[i] = 0;
            last_symbol[i] = -1;
            rotate_start_pos[i] = reels_pos[i];
        }

        can_stop = 0;

        rotate_start_time = get_current_time();

        rotate_control_start_time = 0;
        rotate_start_in_accel = 0;
        rotate_start_swing = 0;
        set_forcestopnow(0);

        madnes_reels_start();
        madnes_add_to_render(rotate_start);
    } else {

        var time = get_current_time() - rotate_start_time;

        if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&
            //behavior_config.reel.acceleration.accelerationHeight &&
            time < behavior_config.reel.acceleration.moveBackTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // back
            var time_perc = ( ( 100 / ( behavior_config.reel.acceleration.moveBackTime * 1000 ) ) * time ) / 100;
            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * time_perc );
            }
        }
        else if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&
            //behavior_config.reel.acceleration.accelerationHeight &&
            time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // keep
            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * 1 );
            }
        }
        else if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&
            behavior_config.reel.acceleration.accelerationHeight &&
            //time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 + behavior_config.reel.acceleration.moveTime * 1000 &&
            time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 + behavior_config.reel.acceleration.moveBackTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // acc
            var time_perc =
                1 - (
                    (
                        (
                            100 / (
                                //behavior_config.reel.acceleration.moveTime * 1000
                                behavior_config.reel.acceleration.moveBackTime * 1000
                            )
                        ) * (
                            time - (
                                behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000
                            )
                        )
                    ) / 100
                );

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * time_perc );
            }


        }
        else if(
            rotate_start_in_accel == 0
        )
        {
            // rotate accel start or repeat

            //madnes_audio_play("REEL_START_reels");
            //madnes_audio_loop("REEL_BG");

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i];
            }

            rotate_start_time = get_current_time();

            if(++rotate_start_swing >= behavior_config.reel.acceleration.swingCount)
            {

                rotate_start_in_accel = 1;

                //rotate_control_start_sym = Math.round(rotate_start_pos[0] / ico_he);
                rotate_control_start_time = get_current_time();
            }
        }
        else if(
            rotate_start_in_accel == 1
        )
        {
            // accel start
            var start_speed = behavior_config.reel.acceleration.accelerationHeight / behavior_config.reel.acceleration.moveBackTime;
            if(!isFinite(start_speed) || isNaN(start_speed))
            {
                start_speed = 0;
            }

            var end_speed = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                end_speed = behavior_config.reel.spin.freeSpinSpeed;
            }

            var end_time = behavior_config.reel.spin.timeToReachFullSpeed * 1000;

            var perc = 0;
            var speed = 0;
            var pos = 0;
            var sampling = 10;

            for(var i = 0; i <= time; i = i * 1 + sampling * 1)
            {
                perc = 100 / end_time * i;
                if(!isFinite(perc) || isNaN(perc))
                {
                    perc = 0;
                }
                speed = ( ( end_speed - start_speed ) * ( perc / 100 ) ) + start_speed * 1;
                pos = pos * 1 + ( speed / ( 1000 / ( sampling * 1 ) ) );
            }

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] + pos * ico_he;
            }

            if(
                !(
                    time < behavior_config.reel.spin.timeToReachFullSpeed * 1000
                )
            )
            {
                pos = 0;

                for(var i = 0; i <= ( behavior_config.reel.spin.timeToReachFullSpeed * 1000 ); i = i * 1 + sampling * 1)
                {
                    perc = 100 / end_time * i;
                    if(!isFinite(perc) || isNaN(perc))
                    {
                        perc = 0;
                    }
                    speed = ( ( end_speed - start_speed ) * ( perc / 100 ) ) + start_speed * 1;
                    pos = pos * 1 + ( speed / ( 1000 / ( sampling * 1 ) ) );
                }

                rotate_control_swing_end = pos;
                from_acce = true;

                madnes_rem_from_render(rotate_start);
                madnes_add_to_render(rotate_control);
            }
        }

        t27_print_reels();
    }
}

// Kontrola probihajici rotace valcu
export var stopposin = new Array();
export var startposin = new Array();

var stopposin_round = new Array();
var stopping = new Array();

export var stopposin_old = new Array();
var stoppostime_br = new Array();
var stoppostime = new Array();

var stoppos_swing = new Array();

var all_set_for_stop = 0;

var from_acce = false;
var jokerCount = 0;

function rotate_control()
{
    var time = get_current_time();

    if(rotated == 1 || all_set_for_stop == 0)
    {
        if(from_acce && behavior_config.reel.spin.motionBlur == 1) {
            for(var i = 0; i < reels_pos.length; i++) {
                /*madnes_sprite_set_frame("reels_bufer_" + i + "_S0", frame_blur);
                madnes_sprite_set_frame("reels_bufer_" + i + "_S1", frame_blur);
                madnes_sprite_set_frame("reels_bufer_" + i + "_S2", frame_blur);*/

                for(var j = 0; j <= 2; j++) {
                    var txt = get_texture_key(madnes_get_texture("reels_bufer_" + i + "_S" + j));

                    if(i === 0 && txt.indexOf("symbol_Bonus") !== -1) {
                        txt = "symbol_Bonus";
                    }

                    if(i === 1 && txt.indexOf("symbol_Bonus") !== -1) {
                        txt = "symbol_R";
                    }

                    if(i === 2 && txt.indexOf("symbol_Bonus") !== -1) {
                        txt = "symbol_Bo";
                    }

                    madnes_set_texture("reels_bufer_" + i + "_S" + j, txt + "_blur");
                }
            }
        }

        from_acce = false;

        // Toci se a zatim se neceka ukonceni

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            if(server_result != null && result_lock == 0)
            {
                stopposin[i] = -1;
                stopposin_round[i] = 0;
                stopping[i] = 0;
                stoppostime_br[i] = -1;
                stoppos_swing[i] = 0;
                stoppostime[i] = -1;
                can_stop = 1;
            }

            alldone[i] = 0;

            var cs = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                cs = behavior_config.reel.spin.freeSpinSpeed;
            }

            reels_pos[i] =
                (
                    rotate_start_pos[i] +
                    (
                        (
                            (
                                (
                                    time - rotate_control_start_time - (
                                        behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                    )
                                ) / 1000
                            ) * cs
                        ) + rotate_control_swing_end
                    ) * ico_he
                );
            var symbdiff =
                (
                    (
                        (
                            (
                                time - rotate_control_start_time - (
                                    behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                )
                            ) / 1000
                        ) * cs
                    ) + rotate_control_swing_end
                );
        }
    }
    else
    {
        // Je na case ukoncit toceni na spravnych pozicich

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            if(stopposin[i] == -1)
            {
                // Nejsou nastaveny pozice pro ukonceni -> nastavuji
                if(forcestopnow == 1)
                {
                    var cs = behavior_config.reel.spin.commonSpeed;
                    if(in_free_spins)
                    {
                        cs = behavior_config.reel.spin.freeSpinSpeed;
                    }

                    var strns = cs * behavior_config.reel.spin.timeToReachNullSpeed;

                    stopposin[i] = Math.round(reels_pos[i] / ico_he) + ( 2 + /* 3 + Math.floor( cs / 4 ) +*/ Math.ceil( strns ) );

                    if(i > 0)
                    {
                        stopposin[i] = ( reels_lenghts[0] - startposin[0] ) + ( ( stopposin_round[0] - 1 ) * reels_lenghts[0] ) + stopposin[0] + startposin[i];
                    }

                }
                else
                {
                    var del = 1;
                    if(typeof behavior_config.reel.spin.delayBetweenReelStops != "undefined")
                    {
                        del = behavior_config.reel.spin.delayBetweenReelStops;
                    }
                    var cs = behavior_config.reel.spin.commonSpeed;
                    if(in_free_spins)
                    {
                        cs = behavior_config.reel.spin.freeSpinSpeed;
                    }

                    var strns = cs * behavior_config.reel.spin.timeToReachNullSpeed;

                    stopposin[i] = Math.round(reels_pos[i] / ico_he) + /*(i * del) + */( 2 + /* 3 + Math.floor( cs / 4 ) +*/ Math.ceil( strns ) );

                    if(i > 0)
                    {
                        stopposin[i] = ( reels_lenghts[0] - startposin[0] ) + ( ( stopposin_round[0] - 1 ) * reels_lenghts[0] ) + stopposin[0] + startposin[i] + ( i * del );
                    }
                }


                while(stopposin[i] <= 0)
                {
                    stopposin[i] = ( reels_lenghts[i] * 1 ) - stopposin[i];
                }

                stopposin_old[i] = stopposin[i];
            }

            var cs = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                cs = behavior_config.reel.spin.freeSpinSpeed;
            }
            var end_break_reel_dist = madnes_get_end_dist();

            //var ttrfs = behavior_config.reel.spin.timeToReachFullSpeed;
            var ttrns = behavior_config.reel.spin.timeToReachNullSpeed;

            if(forcestopnow == 1)
            {
                end_break_reel_dist = 0;
                ttrns = 0.01;
            }

            var symbdiff =
                (
                    (
                        (
                            (
                                time - rotate_control_start_time - (
                                    behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                )
                            ) / 1000
                        ) * cs
                    ) + rotate_control_swing_end
                );

            if(
                forcestopnow == 0 &&
                (
                    (stopposin[i]) - end_break_reel_dist + 0 - ( rotate_start_pos[i] / ico_he ) >= symbdiff &&
                    (stopposin[i]) - end_break_reel_dist + 0 - ( rotate_start_pos[i] / ico_he ) >= 0
                )
            )
            {
                reels_pos[i] =
                    (
                        rotate_start_pos[i] +
                        (
                            (
                                (
                                    (
                                        time - rotate_control_start_time - (
                                            behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                        )
                                    ) / 1000
                                ) * cs
                            ) + rotate_control_swing_end
                        ) * ico_he
                    );
            }
            else if(stoppostime[i] == -1)
            {
                stopping[i] = 1;

                if(stoppostime_br[i] == -1)
                {
                    stoppostime_br[i] = time;
                }

                var dif_time = time - stoppostime_br[i];

                var cur_end = 0;

                if(dif_time <= ttrns * 1000)
                {
                    dif_time = madnes_get_dist_break(dif_time);

                    reels_pos[i] =
                        (
                            ( ( ( stopposin[i] + 0 ) - ( end_break_reel_dist * 1 ) + ( dif_time * 1 ) ) ) * ico_he

                        );
                }
                else
                {
                    cur_end = 1;
                }

                if(cur_end == 1)
                {
                    stoppostime[i] = time;

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 ) * ico_he
                        );

                    if(alldone[i] == 0)
                    {
                        control_show_spin(i);
                        //madnes_control_stop_sound(i);
                        sound_reel_stop(server_result.result.reelMatrix[0][i], i);

                        for(var j in server_result.result.reelMatrix[0][i])
                        {
                            (function(x, y) {
                                setTimeout(function() {
                                    var spriteName = "reels_bufer_" + x + "_S" + ( 2 - y );
                                    var symbolName = get_reel_symbol_name(server_result.result.reelMatrix[0], x, y);

                                    madnes_set_texture(spriteName, symbolName);
                                    //madnes_sprite_set_frame(spriteName, 0);
                                }, (1000 / fps) * j);
                            }(i, j))

                        }
                    }
                }
            }
            else
            {
                var end_time = stoppostime[i];
                var dif_time = time - end_time;

                var bh = behavior_config.reel.brake.brakeHeight;
                var kt = behavior_config.reel.brake.keepTime;
                var mbt = behavior_config.reel.brake.moveBackTime;

                var mt = behavior_config.reel.brake.moveTime;
                //var mt = behavior_config.reel.brake.moveBackTime;


                cs = behavior_config.reel.spin.commonSpeed;
                if(in_free_spins)
                {
                    cs = behavior_config.reel.spin.freeSpinSpeed;
                }

                //cs - rychlost
                //bh - vyska
                //mt = bh / cs;

                var swc = behavior_config.reel.brake.swingCount;

                if(dif_time < mt * 1000)
                {
                    var add_pos = ( ( (100 / ( mt * 1000 ) ) * dif_time ) / 100 ) * bh;

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + add_pos ) * ico_he
                        );
                }
                else if(dif_time < mt * 1000 + kt * 1000)
                {
                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + bh ) * ico_he
                        );
                }
                else if(dif_time < mt * 1000 + kt * 1000 + mbt * 1000)
                {
                    var time2 = dif_time - ( mt * 1000 + kt * 1000 );

                    var add_pos = bh - ( ( ( (100 / ( mbt * 1000 ) ) * time2 ) / 100 ) * bh );

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + add_pos ) * ico_he
                        );

                }
                else
                {
                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0  ) * ico_he
                        );

                    if(++stoppos_swing[i] < swc)
                    {
                        stoppostime[i] = time;
                    }
                    else
                    {
                        alldone[i] = 1;
                    }
                }

            }
        }

        if(alldone.indexOf(0) == -1)
        {
            audioForceStopPlayed = false;
            audioForceJokerPlayed = false;
            audioForceBonusPlayed = false;

            var sound_spin_bg_name = "reel_" + random_spin_sound;
            if(in_free_spins) {
                sound_spin_bg_name = "reel_fs_" + random_spin_sound;
            }

            // madnes_audio_fade_out(sound_spin_bg_name, 250);

            //console.timeEnd('rotate');

            madnes_rem_from_render(rotate_control);
            madnes_reels_stop();
            result_control();
        }
    }

    print_reels();
}

function control_show_spin(reel) {
    if(reel == 1 && !in_free_spins && !madnes_is_in_autostart())
    {
        states.setState(STATES.FORCESPIN);
        // autospin_force_enabled = true;
        // madnes_show_spin();
    }

}

var madnes_get_end_dist_tmp = -1;
var madnes_get_end_dist_tmp_free = -1;
function madnes_get_end_dist()
{
    if(in_free_spins)
    {
        if(madnes_get_end_dist_tmp_free != -1)
        {
            return madnes_get_end_dist_tmp_free;
        }
    }
    else
    {
        if(madnes_get_end_dist_tmp != -1)
        {
            return madnes_get_end_dist_tmp;
        }
    }

    var total_time = behavior_config.reel.spin.timeToReachNullSpeed * 1000;
    var distance = madnes_get_dist_break(total_time);

    if(in_free_spins)
    {
        madnes_get_end_dist_tmp_free = distance;
    }
    else
    {
        madnes_get_end_dist_tmp = distance;
    }

    return distance;
}

function madnes_get_dist_break(time)
{
    var sampling = 10;

    //var end_speed = behavior_config.reel.brake.brakeHeight / behavior_config.reel.brake.moveTime;
    var end_speed = behavior_config.reel.brake.brakeHeight / behavior_config.reel.brake.moveBackTime;

    if(!isFinite(end_speed) || isNaN(end_speed))
    {
        end_speed = 0;
    }

    var start_speed = behavior_config.reel.spin.commonSpeed;
    if(in_free_spins)
    {
        start_speed = behavior_config.reel.spin.freeSpinSpeed;
    }

    end_speed = start_speed;

    var total_time = behavior_config.reel.spin.timeToReachNullSpeed * 1000;

    var distance = 0;

    for(var i = 0; i <= time; i += sampling)
    {
        var proc = 100 - ( ( 100 / total_time ) * i );
        var speed = ( ( start_speed - end_speed ) * ( proc / 100 ) ) + end_speed;
        distance = ( distance * 1 ) + ( speed * sampling ) ;
    }
    distance = distance / 1000;
    return distance;
}

// Pozadavek na dotoceni valce
var rotate_stop_loading = 0;
export function rotate_stop()
{
    if(rotated != 0 && rotate_stop_loading == 0)
    {
        for(var i = 0; i < cylinder_pos.length; i++)
        {
            stopposin_old[i] = -1;
        }
        all_set_for_stop = 0;
        rotate_stop_loading = 1;

        for(var i in server_result.result.reelMatrix[0])
        {
            for(var j in server_result.result.reelMatrix[0][i])
            {

                var symbolName = get_reel_symbol_name(server_result.result.reelMatrix[0], i, j);

                if(behavior_config.reel.spin.motionBlur == 1) {
                    madnes_set_texture("reels_bufer_" + i + "_S" + ( 2 - j ), symbolName + "_blur");
                } else {
                    madnes_set_texture("reels_bufer_" + i + "_S" + ( 2 - j ), symbolName + "");
                }

            }
        }

        setTimeout(function() {
            all_set_for_stop = 1;
            rotate_stop_loading = 0;
        }, (1000 / ( fps ) ));
        set_rotated(0);
    }
}

//function rotate_release()
//{
//	if(autospin_force_enabled)
//	{
//		autospin_force = true;
//	}
//
//	autospin_force_enabled = false;
//}
//
//function forcestop_press()
//{
//	autospin_force = false;
//}

function is_in_autostart()
{
    return !!autostart;
    //return autostart * 1 > 0 || autostart == "∞";
}


/**
 * @param {boolean=} removebet
 */
// function recount_money(removebet)
// {
// 	var new_money = money;
//
// 	if(server_result != null && server_result['result']['credit'] != null)
// 	{
// 		new_money = server_result['result']['credit'] * 1;
// 	}
//
// 	if(server_result != null && server_result['result']['totalWin'] != null)
// 	{
// 		new_money = new_money * 1 + server_result['result']['totalWin'] * 1;
// 	}
//
// 	money = new_money;
//
// 	if(removebet)
// 	{
// 		money = money * 1 - madnes_get_real_bet(bet) * 1;
// 		if(money < 0) {
// 			money = 0;
// 		}
// 	}
// }


//function sound_reel_stop()
//{
//	if(forcestopnow) {
//
//		if(!audioForceStopPlayed) {
//			madnes_audio_play("REEL_STOP");
//			audioForceStopPlayed = true;
//		}
//		return;
//	}
//
//	madnes_audio_play("REEL_STOP");
//}

function sound_reel_stop(reel, i)
{
    if(forcestopnow)
    {
        if(is_symbol_in_reel(reel, "symbol_Joker"))
        {
            if(!audioForceJokerPlayed) {
                madnes_audio_play("reel_stop_joker_2");
                audioForceJokerPlayed = true;
            }

            return;
        }

        if(is_symbol_in_reel(reel, "symbol_Bonus"))
        {
            if(!audioForceBonusPlayed) {
                madnes_audio_play("reel_stop_scatter_2");
                audioForceBonusPlayed = true;
            }

            return;
        }

        if(!audioForceStopPlayed) {
            madnes_audio_play("reel_stop");
            audioForceStopPlayed = true;
        }
        return;
    }


    if(is_symbol_in_reel(reel, "symbol_Joker"))
    {
        madnes_audio_play("reel_stop_joker_" + i);
    }
    else if (is_symbol_in_reel(reel, "symbol_Bonus"))
    {
        madnes_audio_play("reel_stop_scatter_" + i);
    }
    else
    {
        madnes_audio_play("reel_stop");
    }
}

function sound_reel_bg_stop()
{
    madnes_audio_stop("reel_0");
    madnes_audio_stop("reel_1");
    madnes_audio_stop("reel_2");

    madnes_audio_stop("reel_fs_0");
    madnes_audio_stop("reel_fs_1");
    madnes_audio_stop("reel_fs_2");
}

function is_symbol_in_reel(reel, symbol)
{
    for(var i = 0; i < reel.length; i ++) {
        if(picture_convert[reel[i]] == symbol) {
            return true;
        }
    }

    return false;
}

function get_texture_key(textureName)
{
    return textureName.replace('_blur', '');
}